module.exports = __webpack_public_path__ + "img/trash-can.2c4ab554.svg";